export const redirectToOperationsPage = (isRemoAdmin: boolean, projectId: string) => {
  window.location.href = isRemoAdmin ? '/en/remoadmin' : `/corp/qm/queue/${projectId}/operations`;
};
